export const create = {
  form: {
    tankNo: 'Tank No',
    detergentName: 'Detergent Name',
    method: 'Method',
    netWeightMl: 'Net weight ml',
    thresholdQuantity: 'Threshold quantity',
    remainingQuantity: 'Remaining quantity',
    manual: 'Manual',
    automatic: 'Automatic',
    requireTankNo: 'Please input tank no',
    requireDetergentName: 'Please input detergent name',
    requireMethod: 'Please input method',
    requireRemainingQuantity: 'Please input remaining quantity',
    requireThresholdQuantity: 'Please input threshold quantity',
    requireNetWeightMl: 'Please input content weight (ml)',
    invalidLetters: 'Only letters are allowed.',
    invalidNumbers: 'Only numbers are allowed.',
  },
  pageHeader: {
    title: 'Add New Tank',
    back: 'Back',
  },
}
